/**
 * Controls whether or not we use server components to render the hubs page
 */ export var NEXTJS_RSC_LOGGED_IN_HUB_PAGE_241114 = 'NEXTJS_RSC_LOGGED_IN_HUB_PAGE_241114';
